import { render } from "./OrderRatePage.vue?vue&type=template&id=6f46e752&scoped=true"
import script from "./OrderRatePage.vue?vue&type=script&lang=js"
export * from "./OrderRatePage.vue?vue&type=script&lang=js"

import "./OrderRatePage.vue?vue&type=style&index=0&id=6f46e752&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f46e752"]])

export default __exports__